export const SAVE_SITE_CTA_TEXT = 'Сохраните ПДФка.рф, чтобы в следующий раз не искать конвертер.';

export function saveSiteCtaHtml(hidden = false): string {
  return `
    <button type="button" class="save-site-cta" data-install-cta data-install-app aria-label="Сохранить сайт" title="Сохранить сайт" ${hidden ? 'hidden data-install-cta-deferred' : ''}>
      <span class="save-site-cta-icon" aria-hidden="true">＋</span>
      <span class="save-site-cta-text">${SAVE_SITE_CTA_TEXT}</span>
      <span class="save-site-cta-action" data-install-label>Сохранить</span>
    </button>
  `;
}

export function revealSaveSiteCta(host: ParentNode): void {
  host.querySelectorAll<HTMLElement>('[data-install-cta]').forEach((cta) => {
    cta.hidden = false;
    cta.removeAttribute('data-install-cta-deferred');
  });
  notifyInstallActionsChanged();
}

export function notifyInstallActionsChanged(): void {
  window.dispatchEvent(new CustomEvent('pdfka:install-actions-changed'));
}
